export default {
  set: function (key, value)
  {
    try
    {
      window.localStorage.setItem(key, value)
    }
    catch (e)
    {
      console.log('localStorage write failed', e)
    }
  },
  get: function (key)
  {
    try
    {
      return window.localStorage.getItem(key)
    }
    catch (e)
    {
      console.log('localStorage read failed', e)
      return null
    }
  },
  setAsJson: function (key, value)
  {
    try
    {
      this.set(key, JSON.stringify(value))
    }
    catch (e)
    {
      console.log('localStorage write as JSON failed', e)
    }
  },
  getJson: function (key)
  {
    try
    {
      const value = this.get(key)
      return value ? JSON.parse(value) : null
    }
    catch (e)
    {
      console.log('localStorage JSON read failed', key, e)
      return null
    }
  },
  remove: function (key)
  {
    try
    {
      return window.localStorage.removeItem(key)
    }
    catch (e)
    {
      console.log('localStorage remove failed', e)
      return null
    }
  }
}
